exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "\n.footer-link[data-v-13c8bafc] {\n  display: block !important;\n  padding-bottom: 0.25rem;\n  color: #888;\n}\n.footer-link[data-v-13c8bafc]:hover {\n  color: #aaa;\n}\n.section-follow a[data-v-13c8bafc]:hover {\n  opacity: 0.7;\n}\n.section-follow img[data-v-13c8bafc] {\n  width: 2rem;\n  margin-bottom: .5rem;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-13c8bafc","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/FooterList.vue
// module id = nafa
// module chunks = 14